import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import ProtectedRoute from "./ProtectedRoute";
import Layout from "../components/Layout"; // ✅ IMPORTANT

import LoginPage from "../pages/login/LoginPage";
import RegisterPage from "../pages/login/RegisterPage";
import LandingHome from "../pages/HomePage/LandingHome";
// import LandingPage from "../pages/LandingPage";

import MenuPage from "../pages/MenuPage";
import CartPage from "../pages/CartPage";
import OrderPage from "../pages/OrderPage";
import LiveOrderPage from "../pages/LiveOrderPage";
import AccountPage from "../pages/Account/AccountPage";
import LocationPage from "../components/LocationPage";
import FeedbackOption from "../pages/Account/FeedbackOption";
import HelpSupport from "../pages/Account/HelpSupport";

// ✅ Kept About, removed the deleted policy components
import About from "../pages/Account/about/About";

import InvoiceGenerator from "../components/InvoiceGenerator";
import ScrollToTop from "../utils/ScrollToTop";

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Routes>

        {/* PUBLIC */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />

        {/* PROTECTED + LAYOUT */}
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/home" element={<LandingHome />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/orders" element={<OrderPage />} />
          <Route
            path="/invoice/:orderId"
            element={<InvoiceGenerator />}
          />
          <Route path="/live-order/:orderId" element={<LiveOrderPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/profile" element={<AccountPage />} />
          <Route path="/location" element={<LocationPage />} />
          <Route path="/FeedbackOption" element={<FeedbackOption />} />
          <Route path="/help-support" element={<HelpSupport />} />

          {/* ✅ About Page Route */}
          <Route path="/about" element={<About />} />
          {/* Removed the individual policy routes since they are now handled via external window.open links */}

        </Route>

        {/* fallback */}
        <Route path="*" element={<Navigate to="/login" replace />} />

      </Routes>
    </BrowserRouter>
  );
}